import React, { useEffect, useState } from "react";
import Select from "react-select";
import { format,toZonedTime } from "date-fns-tz"; 
import HoverTip from "@mui/material/Tooltip";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import EditNoteIcon from '@mui/icons-material/EditNote';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import LinkIcon from "@mui/icons-material/Link";
import TuneIcon from "@mui/icons-material/Tune";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import apiClient from "../api/apiClient";
import { useNavigate } from "react-router-dom";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";
import LeadAndExecute from "./LeadAndExecute";
import { DataGrid } from "@mui/x-data-grid";
import { McButton } from "@maersk-global/mds-react-wrapper";
import UserAssignModal from "./UserAssignModal";
import { McDateRange } from "@maersk-global/mds-react-wrapper/components-core/mc-date-range";
import { McLoadingIndicator } from "@maersk-global/mds-react-wrapper/mc-loading-indicator";
import ProjectStatus from "./ProjectStatus";
import LiteCustomerForm from "./LiteCustomerForm";
import EventBusyIcon from '@mui/icons-material/EventBusy';
import BulkStatusModel from "./BulkStatusModel";
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import LeadForm from "./LeadForm";
import ViewCreationModal from "./ViewCreationModal";
import TableViewIcon from '@mui/icons-material/TableView';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { apiUrl } from "../authconfig";
const chartData = [
  { name: "India", NotStarted: 230, OnHold: 28, OnTrack: 10 },
  { name: "Brazil", NotStarted: 229, OnHold: 30, OnTrack: 20 },
  { name: "Uruguay", NotStarted: 80, OnHold: 10, OnTrack: 20 },
  { name: "Bangladesh", NotStarted: 219, OnHold: 19, OnTrack: 21 },
  { name: "Sri Lanka", NotStarted: 250, OnHold: 20, OnTrack: 50 },
];

const OpportunityAndFilters = () => {
  const CLOSED_STATUSES = [
    'Cancelled',
    'Complete',
    'Not in Current Scope',
    'Not in Current Scope2',
    'Not in Current Scope-Auto'
  ];
  const [opportunities, setOpportunities] = useState([]);
  const [leadExecuteModal, setLeadExecuteModal] = useState(false);
  const [currentModalData, setCurrentModalData] = useState({});
  const [selectionModal, setSelectionModal] = useState(false);
  const [bulkStatusModel, setBulkStatusModal] = useState(false);
  const [isAllStatus, setIsAllStatus] = useState(false);
  const [exportStatus, setExportStatus] = useState(false);
  const [allData, setAllData] = useState([]);
  const [ViewModal, setViewModal] = useState(false);
  const [allFilters, setAllFilters] = useState();
  const [leadModal,setLeadModal] = useState(false);
  const [allViewList, setAllViewList] = useState('notLoaded');
  const [selectedView,setSelectedView] = useState();
  const currentusermail = JSON.parse(sessionStorage.getItem("user"))?.mail;
 

  const getStartOfWeek = () => {
    let date = new Date();
    let dayOfWeek = date.getDay();
    // Monday to Sunday week
    let difference = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    date.setDate(date.getDate() - difference);
    return date.toISOString().slice(0, 10);
  };

  const getToday = () => {
    let date = new Date();
    return date.toISOString().slice(0, 10);
  };
  const getFormattedRefreshDate = (refreshTime) => {
  if (!refreshTime) return "";
  const date = new Date(refreshTime);
  // Convert to UTC
  const utcDate = toZonedTime(date, "UTC");
  return format(utcDate, "yyyy-MM-dd");
};


  const getFormattedRefreshTime = (refreshTime) => {
  if (!refreshTime) return "";
  const date = new Date(refreshTime);
  const istDate = toZonedTime(date, "Asia/Kolkata");
  return format(istDate, "hh:mm a") + " IST";
};
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  const [assignModal, setAssignModal] = useState(false);
  const [liteModal, setLiteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exportModal, setExportModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportFromDate, setExportFromDate] = useState("");
  const [exportToDate, setExportToDate] = useState("");
  

  const [filterOptions, setFilterOptions] = useState({
    projectIds: [],
    assignedUsers: [],
    opportunityReferences: [],
    accountNames: [],
    area: [],
    region: [],
    vertical: [],
    brand:[],
    customerProgram: [],
    salesChannel: [],
    productBundles: [],
    cxChannels: [],
    assignedToFunctions: [],
    countries: [],
    countryRoles: [],
    projectPhases: [],
    projectStatuses: [],
    regionAreaMap: {},
    fromDate: getStartOfWeek(),
    toDate: getToday(),
  });

  const [selectedFilters, setSelectedFilters] = useState({
    projectIds: null,
    opportunityReferences: null,
    accountNames: null,
    area: null,
    region: null,
    vertical: null,
    brand: null,
    customerProgram: null,
    salesChannel: null,
    assignedUsers: null,
    productBundles: null,
    cxChannels: null,
    assignedToFunctions: null,
    countries: null,
    countryRoles: null,
    projectPhases: null,
    projectStatuses: null,
    regionAreaMap: null,
    fromDate: null,
    toDate: null,
  });

  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const [userNotAssigned, setUserNotAssigned] = useState(false);
  const [dateRefresh,setDateRefresh] = useState()
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    const isExisitingFilter = JSON.parse(localStorage.getItem("filterbody"));
    console.log("isExisitingFilter", isExisitingFilter);
    if (isExisitingFilter) {
      setSelectedFilters(isExisitingFilter);
      applyRetainFilters(isExisitingFilter);
    }
    else{
    fetchAllOpportunities(0, paginationModel.pageSize);
 
    }
    fetchAllFilters();
  
  }, []);
  

  useEffect(() => {

    apiClient.get(`${apiUrl}/api/refreshTimes`).
    then((response) => {
setDateRefresh(response.data[0]);
    })
    .catch((error) => {
      console.error("Error fetching the refresh times:", error);
    });

  },[])

  const fetchAllOpportunities = (page = 0, pageSize = 100) => {
    setLoading(true);
    apiClient
      .get(`${apiUrl}/api/opportunities/getAllPaginated`, {
        params: {
          page: page,
          size: pageSize,
        },
      })
      .then((response) => {
        const { content, totalElements } = response.data;
        setAllData(content);
        setTotalRecords(totalElements);
        const filterData = isAllStatus
          ? content.filter(item => CLOSED_STATUSES.includes(item.projectStatus))
          : content.filter(item => !CLOSED_STATUSES.includes(item.projectStatus));
        setOpportunities(filterData);
        console.log("response.data", response.data);
        setNoRecordsFound(content.length === 0);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching the opportunities data:", error);
      });
  };

  useEffect(() => {
    if(currentusermail){
    fetchViewList()
    }
   
  },[currentusermail])

  const fetchViewList =()=>{
    apiClient.get(`${apiUrl}/api/user-filter-views/search?userEmail=${currentusermail}`)
    .then((response) => {
      setAllViewList(response.data);
      if(selectedView){
      const selectedViewData = response.data.find((item) => item.viewName === selectedView);
      if (selectedViewData) {
        setSelectedFilters(selectedViewData);
        applyRetainFilters(selectedViewData);
      }
      }
    })
    .catch((error) => {
      console.error("Error fetching the filter options:", error);
    });
  }

  const fetchAllFilters = () => {
    apiClient
    .get(
      `${apiUrl}/api/opportunitiesFilters/filters/all`
    )
    .then((response) => {
      setAllFilters(response.data);
      const sourceStatuses = Array.isArray(response?.data?.projectStatuses) ? response.data.projectStatuses : [];
      const filteredStatuses = isAllStatus
        ? sourceStatuses.filter(item => CLOSED_STATUSES.includes(item))
        : sourceStatuses.filter(item => !CLOSED_STATUSES.includes(item));
      const filteredOption = {...response?.data, projectStatuses: filteredStatuses,
        regionAreaMap: response?.data?.regionAreaMap || {}  
      }
      setFilterOptions(filteredOption);
    })
    .catch((error) => {
      console.error("Error fetching the filter options:", error);
    });

  }
  const handleFilterChange = (field, value) => {
    console.log(
      "handleFilterChange called with field:",
      field,
      "and value:",
      value
    );
    setSelectedFilters((prevFilters) => {
      if (field === "region") {
        return {
          ...prevFilters,
          region: value ? value.value : null,
          area: null, 
          countries:null,
        };
       } else if (field === "area") {
          return {
            ...prevFilters,
            area: value ? value.value : null,
            countries: null, 
          };
        } else if (field === "dateFilter") {
        return {
          ...prevFilters,
          fromDate: value ? value.fromDate : null,
          toDate: value ? value.toDate : null,
          fromToChanged: true,
        };
      } else {
        return {
          ...prevFilters,
          [field]: value ? value.value : null,
        };
      }
    });
    if (
      field === "assignedUsers" &&
      !filterOptions.assignedUsers.includes(value?.value)
    ) {
      setUserNotAssigned(true);
    } else {
      setUserNotAssigned(false);
    }
  };

  const setDateFilter = (event) => {
    if (
      selectedFilters.fromDate !== event.target.value.from ||
      selectedFilters.toDate !== event.target.value.to
    )
      console.log("event", event.target.value);
    {
      setSelectedFilters((prevState) => ({
        ...prevState,
        fromDate: event.target.value.from,
        toDate: event.target.value.to,
        fromToChanged: true,
      }));
    }
  };

  const areAllFiltersEmpty = () => {
    return Object.values(selectedFilters).every((value) => value === null);
  };

  const applyFiltersWithPagination = (page = 0, pageSize = 100) => {
    if (areAllFiltersEmpty()) {
      fetchAllOpportunities(page, pageSize);
      localStorage.setItem("filterbody", JSON.stringify(''))
      return;
    }

    setLoading(true);
    localStorage.setItem("filterbody", JSON.stringify(selectedFilters))
    const requestBody = {
      projectIds: selectedFilters.projectIds
        ? [selectedFilters.projectIds]
        : [],
      assignedUsers: selectedFilters.assignedUsers
        ? [selectedFilters.assignedUsers]
        : [],
      opportunityReferences: selectedFilters.opportunityReferences
        ? [selectedFilters.opportunityReferences]
        : [],
      accountNames: selectedFilters.accountNames
        ? [selectedFilters.accountNames]
        : [],
        regionAreaCountryMap: selectedFilters.region
        ? {
            [selectedFilters.region]: selectedFilters.area
              ? {
                  [selectedFilters.area]: selectedFilters.countries ? [selectedFilters.countries] : [],
                }
              : {},
          }
        : {},
        vertical: selectedFilters.vertical
        ? [selectedFilters.vertical]
        : [],
         brand: selectedFilters.brand
        ? [selectedFilters.brand]
        : [],
        customerProgram: selectedFilters.customerProgram
          ? [selectedFilters.customerProgram]
          : [],
        salesChannel: selectedFilters.salesChannel
          ? [selectedFilters.salesChannel]
          : [],
      productBundles: selectedFilters.productBundles
        ? [selectedFilters.productBundles]
        : [],
      cxChannels: selectedFilters.cxChannels
        ? [selectedFilters.cxChannels]
        : [],
      assignedToFunctions: selectedFilters.assignedToFunctions
        ? [selectedFilters.assignedToFunctions]
        : [],
      countryRoles: selectedFilters.countryRoles
        ? [selectedFilters.countryRoles]
        : [],
      projectPhases: selectedFilters.projectPhases
        ? [selectedFilters.projectPhases]
        : [],
      projectStatuses: selectedFilters.projectStatuses
        ? [selectedFilters.projectStatuses]
        : [],
      fromDate: selectedFilters.fromDate ? selectedFilters.fromDate : null,
      toDate: selectedFilters.toDate ? selectedFilters.toDate : null,
      page: page,
      size: pageSize,
    };

    apiClient
      .post(
        `${apiUrl}/api/opportunitiesFilters/filterBasedOppor`,
        requestBody
      )
      .then((response) => {
        // Handle both array response and paginated response object
        const filteredContent = response.data.content || response.data;
        const totalElements = response.data.totalElements || response.data.length;
        
        if (filteredContent && filteredContent.length > 0) {
          setAllData(filteredContent);
          // Apply CLOSED_STATUSES filter
          const filterData = isAllStatus
            ? filteredContent.filter(item => CLOSED_STATUSES.includes(item.projectStatus))
            : filteredContent.filter(item => !CLOSED_STATUSES.includes(item.projectStatus));
          // Update totalRecords to show actual count after secondary filter
          setTotalRecords(filterData.length);
          setOpportunities(filterData);
          setNoRecordsFound(filterData.length === 0);
          setUserNotAssigned(false);
        } else {
          setAllData([]);
          setTotalRecords(0);
          setOpportunities([]);
          setNoRecordsFound(true);
          setUserNotAssigned(true);
        }
      })
      .catch((error) => {
        console.error("Error applying filters:", error);
        setAllData([]);
        setOpportunities([]);
        setNoRecordsFound(true);
        setUserNotAssigned(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const applyFilters = () => {
    setPaginationModel({ pageSize: 100, page: 0 });
    applyFiltersWithPagination(0, 100);
  };

  const applyRetainFilters = (isExisitingFilter) => {
    setLoading(true);
    const payload = {
      projectIds: isExisitingFilter.projectIds
        ? [isExisitingFilter.projectIds]
        : [],
      assignedUsers: isExisitingFilter.assignedUsers
        ? [isExisitingFilter.assignedUsers]
        : [],
      opportunityReferences: isExisitingFilter.opportunityReferences
        ? [isExisitingFilter.opportunityReferences]
        : [],
      accountNames: isExisitingFilter.accountNames
        ? [isExisitingFilter.accountNames]
        : [],
      productBundles: isExisitingFilter.productBundles
        ? [isExisitingFilter.productBundles]
        : [],
        vertical: isExisitingFilter.vertical
        ? [isExisitingFilter.vertical]
        : [],
         brand: isExisitingFilter.brand
        ? [isExisitingFilter.brand]
        : [],
      customerProgram: isExisitingFilter.customerProgram
        ? [isExisitingFilter.customerProgram]
        : [],
      salesChannel: isExisitingFilter.salesChannel
        ? [isExisitingFilter.salesChannel]
        : [],
      cxChannels: isExisitingFilter.cxChannels
        ? [isExisitingFilter.cxChannels]
        : [],
      assignedToFunctions: isExisitingFilter.assignedToFunctions
        ? [isExisitingFilter.assignedToFunctions]
        : [],
      countryRoles: isExisitingFilter.countryRoles
        ? [isExisitingFilter.countryRoles]
        : [],
      projectPhases: isExisitingFilter.projectPhases
        ? [isExisitingFilter.projectPhases]
        : [],
      projectStatuses: isExisitingFilter.projectStatuses
        ? [isExisitingFilter.projectStatuses]
        : [],
      fromDate: isExisitingFilter.fromDate ? isExisitingFilter.fromDate : null,
      toDate: isExisitingFilter.toDate ? isExisitingFilter.toDate : null,
      regionAreaCountryMap: isExisitingFilter.regionAreaCountryMap || {},
      page: 0,
      size: 100,
    };

    apiClient
      .post(
        `${apiUrl}/api/opportunitiesFilters/filterBasedOppor`,
        payload
      )
      .then((response) => {
        // Handle both array response and paginated response object
        const filteredContent = response.data.content || response.data;
        const totalElements = response.data.totalElements || response.data.length;
        
        if (filteredContent && filteredContent.length > 0) {
          setAllData(filteredContent);
          // Apply CLOSED_STATUSES filter
          const filterData = isAllStatus
            ? filteredContent.filter(item => CLOSED_STATUSES.includes(item.projectStatus))
            : filteredContent.filter(item => !CLOSED_STATUSES.includes(item.projectStatus));
          // Update totalRecords to show actual count after secondary filter
          setTotalRecords(filterData.length);
          setOpportunities(filterData); 
          setNoRecordsFound(filterData.length === 0);
          setUserNotAssigned(false);
        } else {
          setAllData([]);
          setTotalRecords(0);
          setOpportunities([]); 
          setNoRecordsFound(true);
          setUserNotAssigned(true);
        }
      })
      .catch((error) => {
        console.error("Error applying filters:", error);
        setAllData([]);
        setOpportunities([]); 
        setNoRecordsFound(true);
        setUserNotAssigned(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
 
  const columns = [
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            color: "#0078d7",
            cursor: "pointer",
          }}
        >
           <HoverTip
              title={!params?.row.assignedUser && "Please assign a user first"}
             
            >
               <div>
              
              
          {params?.row?.countryRole != "Lead" ? (
              <IconButton disabled={!params?.row.assignedUser}>
                {(CLOSED_STATUSES.includes(params?.row?.projectStatus) || (params?.row?.assignedUser && currentusermail != params?.row?.assignedUser)) ? (
                  <HoverTip title="View only">
                    <VisibilityIcon
                      onClick={() => handleSelectionOpen(params?.row)}
                    />
                  </HoverTip>
                ) : (
                  <HoverTip title="Edit">
                    <EditNoteIcon
                      onClick={() => handleEditSelectionOpen(params?.row)}
                    />{" "}
                  </HoverTip> 
                )}
              </IconButton>
           
          ) :
          <IconButton disabled={!params?.row.assignedUser}>
            {(CLOSED_STATUSES.includes(params?.row?.projectStatus) || (params?.row?.assignedUser && currentusermail != params?.row?.assignedUser)) ? (
              <HoverTip title="View only">
                <VisibilityIcon
                  onClick={() => handleOpenLeadForm(params?.row)}
                />
              </HoverTip>
            ) : (
              <HoverTip title="Edit">
                <DriveFileRenameOutlineIcon
                style={{ color: "#0078d7" }}
                  onClick={() => handleEditLeadForm(params?.row)}
                />
              </HoverTip> 
            )}
          </IconButton>
       
        }
        </div>
         </HoverTip>
        </div>
      ),
    },
    // {
    //   field: 'edit2', headerName: 'Customer Onboarding Lite', width: 100, renderCell: (params) => (
    //       <div style={{display:'flex',alignItems:'center',height:'100%',color: '#0078d7',cursor:'pointer'}}> {params?.row?.countryRole != 'Lead' &&<HoverTip title={ !params?.row.assignedUser && "Please assign a user first"}> <IconButton disabled={!params?.row.assignedUser}><EditIcon onClick={() => handleLiteOpen(params?.row)}/></IconButton></HoverTip>}</div>
    //   ),
    // },
    {
      field: "sfdcUrl",
      headerName: "SFDC URL",
      width: 100,
      resizable: true,
      renderCell: (params) => (
        <a
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#0078d7",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <LinkIcon />
        </a>
      ),
    },
    {
      field: "assignedUser",
      headerName: "Assigned User",
      width: 200,
      resizable: true,
    },
    {
      field: "projectId",
      headerName: "Project ID",
      width: 130,
      resizable: true,
    },
    {
      field: "closedWonDate",
      headerName: "Opportunity Close Won Date",
      width: 130,
      resizable: true,
    },
    {
      field: "countryRole",
      headerName: "Country Role",
      width: 130,
      resizable: true,
    },
    {
      field: "onboardingType",
      headerName: "Onboarding Type",
      width: 130,
      resizable: true,
//       renderCell: (params) => (
// <div>{  opportunities.find((item) => item.projectId === params.value)?.fullOnboarding && opportunities.find((item) => item.projectId === params.value)?.liteOnboarding
//   ? ""
//   : opportunities.find((item) => item.projectId === params.value)?.fullOnboarding
//   ? "Full"
//   : "LiteOnboarding"}</div>
//      ),
    },
    {
      field: "opportunityReference",
      headerName: "Opportunity Reference",
      width: 150,
      resizable: true,
    },
    {
      field: "accountName",
      headerName: "Account Name",
      width: 150,
      resizable: true,
    },
    {
      field: "projectStatus",
      headerName: "Project Status",
      width: 130,
      resizable: true,
    },
    {
      field: "opportunityOwner",
      headerName: "Opportunity Owner",
      width: 150,
      resizable: true,
    },
    {
      field: "opportunityOwnerCountry",
      headerName: "Opportunity Owner Country",
      width: 150,
      resizable: true,
    },
    {
      field: "executingCountry",
      headerName: "Executing Country",
      width: 130,
      resizable: true,
    },
    {
      field: "opportunityType",
      headerName: "Opportunity Type",
      width: 150,
      resizable: true,
    },
    {
      field: "productBundles",
      headerName: "Product Family",
      width: 150,
      resizable: true,
    },
    {
      field:"quantityProduct",
      headerName: "Project Volume",
      width: 150,
      resizable: true,
    },
    // {
    //   field: "area",
    //   headerName: "Area",
    //   width: 150,
    //   resizable: true,
    // },
    // {
    //   field: "region",
    //   headerName: "Region",
    //   width: 150,
    //   resizable: true,
    // },
    {
      field: "vertical",
      headerName: "Vertical",
      width: 150,
      resizable: true,
    },
       {
      field: "brand",
      headerName: "Brand",
      width: 150,
      resizable: true,
    },
     {
      field: "productList",
      headerName: "Product List",
      width: 130,
      resizable: true,
    },
      {
      field: "customerProgram",
      headerName: "Customer Program",
      width: 130,
      resizable: true,
    },
      {
      field: "salesChannel",
      headerName: "Sales Channel",
      width: 130,
      resizable: true,
    },
    {
      field: "agreementStartDate",
      headerName: "Agreement Start Date",
      width: 130,
      resizable: true,
    },
    {
      field: "agreementEndDate",
      headerName: "Agreement End Date",
      width: 130,
      resizable: true,
    },
    {
      field: "totalRevenue",
      headerName: "Total Revenue",
      width: 130,
      resizable: true,
    },
    {
      field: "grossProfit",
      headerName: "Gross Profit(USD)",
      width: 130,
      resizable: true,
    },
    {
      field: "cxChannel",
      headerName: "Cx Channel",
      width: 130,
      resizable: true,
    },
    {
      field: "assignedToFunction",
      headerName: "Assigned To Function",
      width: 130,
      resizable: true,
    },
    {
      field: "estimatedGoLiveDate",
      headerName: "Go Live Date",
      width: 130,
      resizable: true,
    },
    {
      field: "projectPhase",
      headerName: "Project Phase",
      width: 130,
      resizable: true,
    },
    {
      field: "estimatedHypercareEndDate",
      headerName: "HyperCare End Date",
      width: 130,
      resizable: true,
    },
    {
      field: "detailReasonForNotOnTrack",
      headerName: "Detail Reason For Not on Track",
      width: 150,
      resizable: true,
    },
  ];

  // Rows from opportunities state
  console.log("opportunitiescheck", opportunities);
  const rows = opportunities.map((opp, index) => ({
    id: index + 1,
    projectId: opp.projectId,
    additionalComments: opp.additionalComments,
    assignedUser: opp.assignedUser,
    closedWonDate: opp.closedWonDate,
    opportunityReference: opp.opportunityReference,
    accountName: opp.accountName,
    executingCountry: opp.executingCountry,
    opportunityType: opp.opportunityType,
    opportunityOwner: opp.opportunityOwner,
    opportunityOwnerCountry: opp.opportunityOwnerCountry,
    productBundles: opp.productBundles,
    quantityProduct:opp.quantityProduct,
    countryRole: opp.countryRole,
    agreementStartDate: opp.agreementStartDate,
    productList: opp.productList,
    area: opp.area,
    region: opp.region,
    agreementEndDate:opp.agreementEndDate,
    totalRevenue: opp.totalRevenue,
    grossProfit: opp.grossProfit,
    cxChannel: opp.cxChannel,
    assignedTo: opp.assignedTo,
    onboardingType:
      opp.countryRole === "Lead"
        ? "NA"
        : (opp.fullOnboarding && opp.liteOnboarding)
        ? ""
        : opp.fullOnboarding
        ? "Full"
        : "Lite",
    createdDate:opp.createdDate,
    assignedToFunction: opp.assignedToFunction,
    scheduledWeeklyVolumes: opp.scheduledWeeklyVolumes,
    averageActualWeeklyVolume: opp.averageActualWeeklyVolume,
    commentsOnLowVolume: opp.commentsOnLowVolume,
    opportunityOwnerArea: opp.opportunityOwnerArea,
    opportunityOwnerRegion: opp.opportunityOwnerRegion,
    executingCountryArea: opp.executingCountryArea,
    executingCountryRegion: opp.executingCountryRegion,
    managerName: opp.managerName,
    manager: opp.manager,
    fullOnboarding: opp.fullOnboarding,
    liteOnboarding: opp.liteOnboarding,
    teamName: opp.teamName,
    country: opp.country,
    cxTeam: opp.cxTeam,
    functionRole: opp.functionRole,
    projectPhase: opp.projectPhase,
    projectStatus: opp.projectStatus,
    estimatedGoLiveDate:opp.estimatedGoLiveDate,
    estimatedHypercareEndDate: opp.estimatedHypercareEndDate,
    customerScvCode:opp.customerScvCode,
    serviceContractNumber:opp.serviceContractNumber,
    opportunityName:opp.opportunityName,
    vertical:opp.vertical,
    brand:opp.brand,
    salesChannel:opp.salesChannel,
    customerProgram:opp.customerProgram,
    detailReasonForNotOnTrackShoCompletionValidation:
      opp.detailReasonForNotOnTrackShoCompletionValidation,
    detailReasonForNotOnTrackInternalOnboarding:
      opp.detailReasonForNotOnTrackInternalOnboarding,
    detailReasonForNotOnTrackOthers: opp.detailReasonForNotOnTrackOthers,
    detailReasonForNotOnTrack: opp.detailReasonForNotOnTrack,
    supportRequiredFrom: opp.supportRequiredFrom,
    completion: opp.completion,
    partyResponsibleForNotOnTrack: opp.partyResponsibleForNotOnTrack,
    projectStatusNumeric: opp.projectStatusNumeric,
    modifiedDate: format(toZonedTime(new Date(), "Europe/Copenhagen"), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
    sfdcUrl: opp.sfdcUrl,
    //...opp
  }));
  console.log(
    "opportunities",
    opportunities
  );

  const handleOpen = () => {
    setLeadExecuteModal(true);
  };

  const handleSelectionOpen = (opp) => {
    setCurrentModalData(opp);
    if (
      (opp.projectStatus == "Cancelled" ||
        opp.projectStatus == "Not in Current Scope") &&
      opp.fullOnboarding &&
      opp.liteOnboarding
    ) {
      setLeadExecuteModal(true);
    } else if (opp?.fullOnboarding && opp?.liteOnboarding) {
      setSelectionModal(true);
    } else if (opp?.fullOnboarding && !opp?.liteOnboarding) {
      setLeadExecuteModal(true);
    } else if (!opp?.fullOnboarding && opp?.liteOnboarding) {
      setLiteModal(true);
    }
  };


  const handleEditSelectionOpen = (opp) => {
    const currentusermail = JSON.parse(sessionStorage.getItem("user"))?.mail;
if(currentusermail == opp.assignedUser ){
    setCurrentModalData(opp);
    if (opp?.fullOnboarding && opp?.liteOnboarding) {
      setSelectionModal(true);
    } else if (opp?.fullOnboarding && !opp?.liteOnboarding) {
      setLeadExecuteModal(true);
    } else if (!opp?.fullOnboarding && opp?.liteOnboarding) {
      setLiteModal(true);
    }
  }
  else{

    alert("You are not assigned to this project")
  }
  }

  const handleEditLeadForm = (opp) => {
    const currentusermail = JSON.parse(sessionStorage.getItem("user"))?.mail;
if(currentusermail == opp.assignedUser ){
    setCurrentModalData(opp);
    if (opp?.countryRole == "Lead") {
      setLeadModal(true);
    } 
  }
  else{

    alert("You are not assigned to this project")
  }
  }

  const handleOpenLeadForm = (opp) => {


    setCurrentModalData(opp);
    if (opp?.countryRole == "Lead") {
      setLeadModal(true);
    } 
  }

  const handleLiteOpen = () => {
    setLiteModal(true);
  };

  const handleClose = () => {
    setLeadExecuteModal(false);
    setLiteModal(false);
    setLeadModal(false);
    setSelectionModal(false);
    fetchAllFilters();
    applyFilters()
    setRowSelectionModel([]);
  };
  const handleCloseForm = () => {
    fetchAllFilters();
    applyFilters()
    setRowSelectionModel([]);
  }

  const clearfilters = () => {
    setSelectedView()
    setPaginationModel({ pageSize: 100, page: 0 });
    fetchAllOpportunities(0, 100);
    setSelectedFilters({
      projectIds: null,
      opportunityReferences: null,
      accountNames: null,
      assignedUsers: null,
      area: null,
      region: null,
      vertical: null,
      brand: null,
      customerProgram: null,
      salesChannel: null,
      productBundles: null,
      cxChannels: null,
      assignedToFunctions: null,
      countries: null,
      countryRoles: null,
      projectPhases: null,
      projectStatuses: null,
      fromDate: null,
      toDate: null,
    })
    setRowSelectionModel([]);

  }

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
    if (areAllFiltersEmpty()) {
      fetchAllOpportunities(newPaginationModel.page, newPaginationModel.pageSize);
    } else {
      // Apply pagination to filtered results
      applyFiltersWithPagination(newPaginationModel.page, newPaginationModel.pageSize);
    }
  };

  const toggleStatus =()=>{
    setRowSelectionModel([]);
    console.log("opportunities2",!isAllStatus,allFilters)
    // Guard against allFilters being undefined while data is still loading
    const statusList = Array.isArray(allFilters?.projectStatuses) ? allFilters.projectStatuses : [];
    const filteredStatuses = !isAllStatus
      ? statusList.filter(item => CLOSED_STATUSES.includes(item))
      : statusList.filter(item => !CLOSED_STATUSES.includes(item));
    const filteredOption = { ...(allFilters || {}), projectStatuses: filteredStatuses };
    setFilterOptions(filteredOption);

    const filterData = !isAllStatus
      ? allData.filter(item => CLOSED_STATUSES.includes(item.projectStatus))
      : allData.filter(item => !CLOSED_STATUSES.includes(item.projectStatus));
    setOpportunities(filterData)
    setIsAllStatus(!isAllStatus)
  }

  const handleInputChange = (inputValue, actionMeta) => {
    if (
      actionMeta.action === "input-change" &&
      !filterOptions.assignedUsers.some((user) => user?.includes(inputValue))
    ) {
      setUserNotAssigned(true);
    } else {
      setUserNotAssigned(false);
    }
  };

  const OpenStatusModel = () => {

    if(rowSelectionModel.length == 0){
      alert("Please select one or more rows to update the status")
    }
    else if (
      rows
        ?.filter((item) => rowSelectionModel?.includes(item?.id))
        .every(
          (item) => item?.assignedUser && item?.projectStatus != "Complete"
        )
    ) {
      setBulkStatusModal(true);
    } else if (
      rows
        ?.filter((item) => rowSelectionModel?.includes(item?.id))
        .some((item) => item?.projectStatus == "Complete")
    ) {
      alert(
        "Selected Project ID is in Complete Status hence this action cannot be performed"
      );
    } else {
      alert("Please assign a user first");
    }
  };

  const formatExportHeaderForDisplay = (header) => {
    const noBom = header.replace(/^\uFEFF/, "");
    const withSpaces = noBom.replace(/_/g, " ");
    return withSpaces
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleExportFilteredData = async (fromDate, toDate) => {
    setExportLoading(true);
    try {
      const response = await apiClient.get(
        `${apiUrl}/api/export/ionis-dataset`,
        {
          params: {
            fromDate,
            toDate,
          },
          responseType: "blob",
        }
      );

      const disposition = response.headers["content-disposition"] || "";
      const matchedFileName = disposition.match(/filename=\"?([^\";]+)\"?/i);
      const fileName =
        matchedFileName?.[1] ||
        `ionis_dataset_${format(new Date(), "yyyyMMdd_HHmmss")}.csv`;

      const csvText = await response.data.text();
      const [firstLine, ...otherLines] = (csvText || "")
        .replace(/\r\n?/g, "\n")
        .split("\n");

      if (!firstLine) {
        setExportLoading(false);
        setExportModal(false);
        alert("There is no data in the selected date range.");
        return;
      }

      const rawHeaders = firstLine.split(",");
      const formattedHeaders = rawHeaders.map((h) => {
        const unquoted = h.replace(/^"|"$/g, "");
        const display = formatExportHeaderForDisplay(unquoted);
        return `"${display.replace(/"/g, '""')}"`;
      });
      const formattedHeaderLine = formattedHeaders.join(",");
      const finalCsvText = [formattedHeaderLine, ...otherLines].join("\n");

      const csvBlob = new Blob([`\uFEFF${finalCsvText}`], {
        type: "text/csv;charset=utf-8;",
      });
      const url = window.URL.createObjectURL(csvBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setExportLoading(false);
      setExportModal(false);
    } catch (error) {
      setExportLoading(false);
      setExportModal(false);
      alert("Failed to export data. Please try again.");
    }
  };

  const handleExportProductData = async (fromDate, toDate) => {
    setExportLoading(true);
    try {
      const response = await apiClient.get(
        `${apiUrl}/api/export/product-dataset`,
        {
          params: {
            fromDate,
            toDate,
          },
          responseType: "blob",
        }
      );

      const disposition = response.headers["content-disposition"] || "";
      const matchedFileName = disposition.match(/filename=\"?([^\";]+)\"?/i);
      const fileName =
        matchedFileName?.[1] ||
        `product_dataset_${format(new Date(), "yyyyMMdd_HHmmss")}.csv`;

      const csvText = await response.data.text();
      const [firstLine, ...otherLines] = (csvText || "")
        .replace(/\r\n?/g, "\n")
        .split("\n");

      if (!firstLine) {
        setExportLoading(false);
        setExportModal(false);
        alert("There is no data in the selected date range.");
        return;
      }

      const rawHeaders = firstLine.split(",");
      const formattedHeaders = rawHeaders.map((h) => {
        const unquoted = h.replace(/^"|"$/g, "");
        const display = formatExportHeaderForDisplay(unquoted);
        return `"${display.replace(/"/g, '""')}"`;
      });
      const formattedHeaderLine = formattedHeaders.join(",");
      const finalCsvText = [formattedHeaderLine, ...otherLines].join("\n");

      const csvBlob = new Blob([`\uFEFF${finalCsvText}`], {
        type: "text/csv;charset=utf-8;",
      });
      const url = window.URL.createObjectURL(csvBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setExportLoading(false);
      setExportModal(false);
    } catch (error) {
      setExportLoading(false);
      setExportModal(false);
      alert("Failed to export data. Please try again.");
    }
  }

  const setExportDateRange = (from = "", to = "") => {
    setExportFromDate(from);
    setExportToDate(to);
  };

  const openExportModal = () => {
    setExportStatus(false);
    setExportDateRange("", "");
    setExportModal(true);
  };

  const handleExportDateRangeChange = ({ target: { value } = {} }) => {
    setExportDateRange(value?.from, value?.to);
  };

  const submitExportWithDateRange = () => {
    if (!exportFromDate || !exportToDate) {
      alert("Please select both From and To dates");
      return;
    }

    if (exportFromDate > exportToDate) {
      alert("From date cannot be greater than To date");
      return;
    }
if(!exportStatus)
{
handleExportFilteredData(exportFromDate, exportToDate);

}
else{
handleExportProductData(exportFromDate, exportToDate);

}
    
  };

  const noOptionsMessage = () => {
    return (
      <span style={{ color: "red" }}>User has not been assigned any case</span>
    );
  };
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f8ff" : "white", 
      color: state.isFocused ? "#0078d7" : "black", 
      cursor: "pointer",
    }),
    control: (provided) => ({
      ...provided,
      borderColor: "#cfcfcf",
      "&:hover": {
        borderColor: "#0078d7", 
      },
    }),
  };

  const onViewClick = (viewName) => {
    const currentView = allViewList?.find((item) => item.viewName === viewName);
    if (currentView) {
      setSelectedView(viewName)
      setSelectedFilters(currentView)
      applyRetainFilters(currentView)

    }
  }

  return (
    <>
      <div
        style={{
          fontSize: "20px",
          background: "#f7f7f7",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
          padding: "20px 10px",
        }}
      >
        Project Queue
<div style={{ fontSize:'14px',fontWeight:'normal'}}>Last Refresh Date: {getFormattedRefreshDate(dateRefresh?.refreshTime)}
<div style={{ fontSize: '14px' }}>Last Refresh Time: {getFormattedRefreshTime(dateRefresh?.refreshTime)}</div>
</div>
 </div>
      <div style={{ marginTop: "0px", background: "#f7f7f7" }}>
        <McModal
          closed={() => setSelectionModal(false)}
          open={selectionModal}
          dimension="small"
        >
          <p
            style={{
              fontSize: "16px",
              padding: "5px",
              fontFamily: "Maersk Text",
            }}
          >
            <b>Please Select Form Type</b>
          </p>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "30px" }}
          >
            <Button
              variant="contained"
              color="primary"
              disabled={!currentModalData?.fullOnboarding}
              onClick={handleOpen}
              style={{
                fontFamily: "Maersk Text",
                background: "rgb(66,176,213)",
              }}
            >
              Full Customer Onboarding
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!currentModalData?.liteOnboarding}
              onClick={handleLiteOpen}
              style={{
                fontFamily: "Maersk Text",
                background: "rgb(66,176,213)",
              }}
            >
              Customer Onboarding Lite
            </Button>
          </div>
        </McModal>
        <McModal
          className=""
          closed={handleClose}
          open={leadExecuteModal}
          width="100vw"
          height="100vh"
        >
          <div className="modal">
            <div
              style={{
                marginBottom: "20px",
                background: "#ededed",
                color: "grey",
                justifyContent: "space-evenly",
                borderRadius: "5px",
              }}
            >
              <p
                style={{
                  fontSize: "32px",
                  padding: "10px",
                  fontFamily: "Maersk Text",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <b> Lead and Execute</b>
                {currentModalData?.liteOnboarding && (
                  <div
                    style={{
                      color: "#0078d7",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setLiteModal(true);
                      setLeadExecuteModal(false);
                    }}
                  >
                    Switch to Customer Onboarding Lite Form
                  </div>
                )}
              </p>
            </div>
            <LeadAndExecute
              currentModalData={currentModalData}
              setCurrentModalData={setCurrentModalData}
              handleClose={handleCloseForm}
              fetchAllOpportunities={fetchAllOpportunities}
            />
          </div>
        </McModal>
        <McModal
          className=""
          closed={handleClose}
          open={leadModal}
          width="100vw"
          height="100vh"
        >
          <div className="modal">
            <div
              style={{
                marginBottom: "20px",
                background: "#ededed",
                color: "grey",
                justifyContent: "space-evenly",
                borderRadius: "5px",
              }}
            >
              <p
                style={{
                  fontSize: "32px",
                  padding: "10px",
                  fontFamily: "Maersk Text",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <b>Lead Form</b>
              </p>
            </div>
            <LeadForm
              currentModalData={currentModalData}
              handleClose={handleCloseForm}
              setCurrentModalData={setCurrentModalData}
            />
          </div>
        </McModal>
        <McModal
          className=""
          closed={handleClose}
          open={liteModal}
          width="100vw"
          height="100vh"
        >
          <div className="modal">
            <div
              style={{
                marginBottom: "20px",
                background: "#ededed",
                color: "grey",
                borderRadius: "5px",
              }}
            >
              <p
                style={{
                  fontSize: "32px",
                  padding: "10px",
                  fontFamily: "Maersk Text",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <b> Customer Onboarding Lite</b>
                {currentModalData?.fullOnboarding && (
                  <div
                    style={{
                      color: "#0078d7",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setLeadExecuteModal(true);

                      setLiteModal(false);
                    }}
                  >
                    Switch to Full Customer Onboarding Form
                  </div>
                )}
              </p>
            </div>
            <LiteCustomerForm
              currentModalData={currentModalData}
              handleClose={handleCloseForm}
              setCurrentModalData={setCurrentModalData}
            />
          </div>
        </McModal>
        <div style={{ padding: "10px" }}>
          {/* Filters */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              marginBottom: "20px",
              border: "1px solid #cfcfcf",
              padding: "10px",
              backgroundColor: "#fff",
            }}
          >
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions?.projectIds?.map((id) => ({
                  value: id,
                  label: id,
                }))}
                placeholder="Project ID"
                value={
                  selectedFilters?.projectIds && {
                    value: selectedFilters?.projectIds,
                    label: selectedFilters?.projectIds,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("projectIds", value)}
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.opportunityReferences?.map((ref) => ({
                  value: ref,
                  label: ref,
                }))}
                placeholder="Opportunity Reference"
                isClearable
                value={
                  selectedFilters?.opportunityReferences && {
                    value: selectedFilters?.opportunityReferences,
                    label: selectedFilters?.opportunityReferences,
                  }
                }
                onChange={(value) =>
                  handleFilterChange("opportunityReferences", value)
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.accountNames?.map((name) => ({
                  value: name,
                  label: name,
                }))}
                placeholder="Account Name"
                isClearable
                value={
                  selectedFilters?.accountNames && {
                    value: selectedFilters?.accountNames,
                    label: selectedFilters?.accountNames,
                  }
                }
                onChange={(value) => handleFilterChange("accountNames", value)}
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.assignedUsers?.map((user) => ({
                  value: user,
                  label: user,
                }))}
                placeholder="Assigned User"
                isClearable
                value={
                  selectedFilters?.assignedUsers && {
                    value: selectedFilters?.assignedUsers,
                    label: selectedFilters?.assignedUsers,
                  }
                }
                onChange={(value) => {
                  handleFilterChange("assignedUsers", value);
                }}
                onInputChange={handleInputChange}
                noOptionsMessage={noOptionsMessage}
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions?.productBundles?.map((family) => ({
                  value: family,
                  label: family,
                }))}
                placeholder="Product Family"
                value={
                  selectedFilters?.productBundles && {
                    value: selectedFilters?.productBundles,
                    label: selectedFilters?.productBundles,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("productBundles", value)
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions?.cxChannels?.map((channel) => ({
                  value: channel,
                  label: channel,
                }))}
                placeholder="CX Channel"
                value={
                  selectedFilters?.cxChannels && {
                    value: selectedFilters?.cxChannels,
                    label: selectedFilters?.cxChannels,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("cxChannels", value)}
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions?.assignedToFunctions?.map((func) => ({
                  value: func,
                  label: func,
                }))}
                placeholder="Assigned To Function"
                value={
                  selectedFilters?.assignedToFunctions && {
                    value: selectedFilters?.assignedToFunctions,
                    label: selectedFilters?.assignedToFunctions,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("assignedToFunctions", value)
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={Object.keys(filterOptions.regionAreaCountryMap || {}).map((region) => ({
                  value: region,
                  label: region,
                }))}
                placeholder="Region"
                value={
                  selectedFilters?.region && {
                    value: selectedFilters?.region,
                    label: selectedFilters?.region,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("region", value)
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={
                  selectedFilters?.region &&
                  filterOptions?.regionAreaCountryMap &&
                  typeof filterOptions.regionAreaCountryMap[selectedFilters.region] === "object"
                    ? Object.keys(filterOptions.regionAreaCountryMap[selectedFilters.region]).map((area) => ({
                        value: area,
                        label: area,
                      }))
                    : []
                }
                placeholder="Area"
                value={
                  selectedFilters?.area && {
                    value: selectedFilters?.area,
                    label: selectedFilters?.area,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("area", value)
                }
                noOptionsMessage={() =>
                  !selectedFilters?.region 
                    ?       <span style={{ color: "red" }}>Please select a value in Region first</span>
                    : "No options available"
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={
                  selectedFilters?.region &&
                  selectedFilters?.area &&
                  filterOptions?.regionAreaCountryMap &&
                  filterOptions.regionAreaCountryMap[selectedFilters.region] &&
                  Array.isArray(filterOptions.regionAreaCountryMap[selectedFilters.region][selectedFilters.area])
                    ? filterOptions.regionAreaCountryMap[selectedFilters.region][selectedFilters.area].map((country) => ({
                        value: country,
                        label: country,
                      }))
                    : []
                }
                placeholder="Country"
                value={
                  selectedFilters?.countries && {
                    value: selectedFilters?.countries,
                    label: selectedFilters?.countries,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("countries", value)}
                noOptionsMessage={() =>
                  !selectedFilters?.region || !selectedFilters?.area
                    ? <span style={{ color: "red" }}>Please select values in Region and Area</span>
                    : "No options available"
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.countryRoles?.map((role) => ({
                  value: role,
                  label: role,
                }))}
                placeholder="Country Role"
                value={
                  selectedFilters?.countryRoles && {
                    value: selectedFilters?.countryRoles,
                    label: selectedFilters?.countryRoles,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("countryRoles", value)}
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.projectPhases?.filter(status=>{
                  if(isAllStatus){
                    return status == 'Close Project'
                  }
                  else{
                    return status != 'Close Project'
                  }
                })?.map((phase) => ({
                  value: phase,
                  label: phase,
                }))}
                placeholder="Project Phase"
                value={
                  selectedFilters?.projectPhases && {
                    value: selectedFilters?.projectPhases,
                    label: selectedFilters?.projectPhases,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("projectPhases", value)}
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.projectStatuses?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Project Status"
                value={
                  selectedFilters?.projectStatuses && {
                    value: selectedFilters?.projectStatuses,
                    label: selectedFilters?.projectStatuses,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("projectStatuses", value)
                }
              />
            </div>
          
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.vertical?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Vertical"
                value={
                  selectedFilters?.vertical && {
                    value: selectedFilters?.vertical,
                    label: selectedFilters?.vertical,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("vertical", value)
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.brand?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Brand"
                value={
                  selectedFilters?.brand && {
                    value: selectedFilters?.brand,
                    label: selectedFilters?.brand,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("brand", value)
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.customerProgram?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Customer Program"
                value={
                  selectedFilters?.customerProgram && {
                    value: selectedFilters?.customerProgram,
                    label: selectedFilters?.customerProgram,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("customerProgram", value)
                }
              />
            </div>
            <div style={{ width: "220px" }}>
              <Select
                styles={customStyles}
                options={filterOptions.salesChannel?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Sales Channel"
                value={
                  selectedFilters?.salesChannel && {
                    value: selectedFilters?.salesChannel,
                    label: selectedFilters?.salesChannel,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("salesChannel", value)
                }
              />
            </div>

            <div
              style={{
                border: "1px solid #cfcfcf",
                borderRadius: "4px",
                padding: "0 0 0 10px",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
              }}
            >
              <McDateRange
                className="custom-date-range"
                labelposition="left"
                name="dateFilter"
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
                fit="small"
                style={{ marginRight: "12px" }}
                input={(value) => setDateFilter(value)}
                value={{
                  from: selectedFilters.fromDate,
                  to: selectedFilters.toDate,
                }} 
              />
            </div>
            <div style={{ cursor: "pointer" }} onClick={applyFilters}>
              <HoverTip title="Apply Filter">
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    fontFamily: "Maersk Text",
                    background: "rgb(66,176,213)",
                  }}
                >
                  <TuneIcon />
                </Button>{" "}
              </HoverTip>
            </div>
            <div style={{ cursor: "pointer" }} onClick={clearfilters}>
              <HoverTip title="Clear Filter">
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    fontFamily: "Maersk Text",
                    background: "rgb(66,176,213)",
                  }}
                >
                  <FilterAltOffIcon />
                </Button>{" "}
              </HoverTip>
            </div>
            <div>
              <HoverTip
                title={
                  !isAllStatus
                    ? "Toggle to Closed Cases"
                    : "Toggle to Open Cases"
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={toggleStatus}
                  style={{
                    fontFamily: "Maersk Text",
                    background: "rgb(66,176,213)",
                  }}
                >
                  {!isAllStatus ? <ToggleOffIcon /> : <ToggleOnIcon />}
                </Button>
              </HoverTip>
            </div>
            <div>
              <HoverTip
                title={
                  
                    "Create/Edit Views"
                    
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  disabled={ allViewList == 'notLoaded'}
                  onClick={()=>setViewModal(true)}
                  style={{
                    fontFamily: "Maersk Text",
                    background: "rgb(66,176,213)",
                  }}
                >
                 <TableViewIcon/>
                </Button>
              </HoverTip>
            </div>
           
            {Array.isArray(allViewList) && allViewList?.length > 0 && allViewList?.sort((a,b)=>a.viewName?.localeCompare(b.viewName))?.map((view)=> <div> <HoverTip title={view?.viewName}>
              <Button
                style={{
                  width: "50px",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: "Maersk Text",
                  backgroundColor: "rgb(66, 176, 213)",
                  border : selectedView == view?.viewName ? "2px solid #0078d7" : "none",
                }}
                variant="contained"
                onClick={() => onViewClick(view?.viewName)}
              >
                {view?.viewName}
              </Button>
            </HoverTip> </div>)

            }
           
          </div>

          {/* <div style={{ marginBottom: '5px', display: 'flex', justifyContent: 'center'  }}>
        <BarChart width={500} height={200} data={chartData}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="NotStarted" stackId="a" fill="#8884d8" />
          <Bar dataKey="OnHold" stackId="a" fill="#82ca9d" />
          <Bar dataKey="OnTrack" stackId="a" fill="#ffc658" />
        </BarChart>
      </div> */}

          <div style={{ padding: "20px 0", display: "flex", gap: "20px" }}>
            <HoverTip title="Assign User">
              <Button
                style={{
                  width: "50px",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: "Maersk Text",
                  backgroundColor: "rgb(66, 176, 213)",
                }}
                variant="contained"
                onClick={() =>
                  rowSelectionModel?.length
                    ? setAssignModal(true)
                    : alert("Please select a project to assign user")
                }
              >
                <ManageAccountsIcon />
              </Button>
            </HoverTip>

            <HoverTip title="Cancel/Not in current Scope">
              <Button
                style={{
                  width: "50px",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: "Maersk Text",
                  backgroundColor: "rgb(66, 176, 213)",
                }}
                variant="contained"
                onClick={OpenStatusModel}
              >
                <EventBusyIcon />
              </Button>
            </HoverTip>

            <HoverTip title="Export Data">
              <Button
                style={{
                  width: "50px",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: "Maersk Text",
                  backgroundColor: "rgb(66, 176, 213)",
                }}
                variant="contained"
                onClick={openExportModal}
              >
                <FileDownloadIcon />
              </Button>
            </HoverTip>
            {console.log("View1 Payload:", allViewList)}
            
          </div>

          {assignModal && (
            <UserAssignModal
              assignModal={assignModal}
              setAssignModal={setAssignModal}
              setRowSelectionModel={setRowSelectionModel}
              rowSelectionModel={rowSelectionModel}
              rows={rows}
              handleClose={handleClose}
              userListOptionToConcat={filterOptions.assignedUsers}
            />
          )}

          {bulkStatusModel && (
            <BulkStatusModel
              bulkStatusModel={bulkStatusModel}
              setBulkStatusModal={setBulkStatusModal}
              setRowSelectionModel={setRowSelectionModel}
              rowSelectionModel={rowSelectionModel}
              rows={rows}
              handleClose={handleClose}
            />
          )}

         {ViewModal && <ViewCreationModal
          handleClose={()=>setViewModal(false)}
          ViewModal={ViewModal}
          filterOptions={filterOptions}
          fetchViewList={fetchViewList}
          allViewList={allViewList}
          />
         }

          <McModal
            closed={() => { if (!exportLoading) setExportModal(false); }}
            open={exportModal}
            width="45vw"
            height="60vh"
          >
            <div
              style={{
                marginBottom: "20px",
                background: "rgb(66, 176, 213)",
                color: "#fff",
                justifyContent: "space-evenly",
                borderRadius: "5px",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  margin: "5px",
                  fontFamily: "Maersk Text",
                }}
              >
                <b>Export Data</b>
              </p>
            </div>
             <div style={{marginBottom:'20px'}}>
              <HoverTip
                title={
                  exportStatus
                    ? "Toggle to Export Product Data"
                    : "Toggle to Opportunities Data"
                }
              >
                <Button
                size="small"
                  variant="outlined"
                  color="primary"
                  onClick={()=> setExportStatus(!exportStatus)}
                  style={{
                    fontFamily: "Maersk Text",
                    background: "rgb(66,176,213)",
                  }}
                >
                  {exportStatus ? <ToggleOffIcon /> : <ToggleOnIcon />}
                </Button>
                {!exportStatus ? <span style={{marginLeft:'10px', fontWeight: 'bold'}}>Filtering By Created Date for Project Queue </span> : <span style={{marginLeft:'10px', fontWeight: 'bold'}}>Filtering By Added Date for Product Details </span>}
              </HoverTip>
            </div>

            <div
              style={{
                border: "1px solid #cfcfcf",
                borderRadius: "4px",
                padding: "10px 20px ",
                backgroundColor: "#fff",
                display: "flex", 
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <McDateRange
                className="custom-date-range"
                labelposition="left"
                name="exportDateFilter"
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
                fromlabel={!exportStatus ? "Created From" : "Added From"}
                tolabel={!exportStatus ? "Created To" : "Added To"}
                fit="small"
                style={{ width: "100%" }}
                input={(value) => handleExportDateRangeChange(value)}
                value={{
                  from: exportFromDate,
                  to: exportToDate,
                }}
              />
            </div>
            <div style={{ marginBottom: "20px",marginTop:'20px' }}>
              {exportLoading && (
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                  <McLoadingIndicator appearance="primary" label="Processing" />
                </div>
              )}
              <Button
                variant="contained"
                onClick={submitExportWithDateRange}
                style={{
                  display: exportLoading ? "none" : "block",
                  margin: "20px auto",
                  justifyItems: "center",
                  width: "150px",
                  padding: "10px",
                  fontFamily: "Maersk Text",
                  backgroundColor:
                    exportFromDate && exportToDate ? "#00243D" : "#9e9e9e",
                }}
                disabled={!exportFromDate || !exportToDate || exportLoading}
              >
                Submit
              </Button>
            </div>
          </McModal>

          {loading ? (
            <McLoadingIndicator
              appearance="primary"
              style={{ fontSize: "36px", transform: "scale(3)" }}
            />
          ) : (
            <div className="OpportunitiesContainer" style={{}}>
              <DataGrid
                checkboxSelection={true}
                rows={opportunities.map((row, index) => {
                  return {
                    ...row,
                  id: index + 1,
                  onboardingType:
                    row.countryRole === "Lead"
                      ? "NA"
                      : (row.fullOnboarding && row.liteOnboarding)
                      ? ""
                      : row.fullOnboarding
                      ? "Full"
                      : "Lite",
                }})}
                columns={columns}
                pageSizeOptions={[5, 10, 20, 100]}
                paginationModel={paginationModel}
                onPaginationModelChange={handlePaginationModelChange}
                disableSelectionOnClick
                disableRowSelectionOnClick
                components={{
                  ColumnHeaderCheckbox: () => null,
                }}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                  setRowSelectionModel(newRowSelectionModel);
                }}
                rowSelectionModel={rowSelectionModel}
                rowCount={totalRecords}
                paginationMode="server"
                sx={{
                  fontFamily: "Maersk Text",
                  "& .MuiDataGrid-columnHeaders .MuiDataGrid-row--borderBottom":
                    {
                      backgroundColor: "#ededed",
                    },
                  "& .MuiDataGrid-virtualScrollerContent": {
                    backgroundColor: "white",
                  },
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OpportunityAndFilters;
